import { nullExpandArray } from '@SonarCX/utilities'

interface FlowOrder {
  flow_order: number
}

export const sortByFlowOrder = <T extends FlowOrder>(arr: T[]) => {
  return arr.slice().sort((a, b) => {
    const aOrder = a.flow_order ?? 0
    const bOrder = b.flow_order ?? 0
    return aOrder - bOrder
  })
}

export const doDragDrop = (
  taskSettings: any[],
  sourceID: string,
  targetID: string,
  after?: boolean
) => {
  // Add gaps to the array
  const expanded = nullExpandArray(taskSettings)

  // Find indices of both settings in newly expanded array
  const sourceIdx = expanded.findIndex(item => item?.id === sourceID)
  const targetIdx = expanded.findIndex(item => item?.id === targetID)

  // Perform move
  expanded[targetIdx + (after ? 1 : -1)] = expanded[sourceIdx]
  expanded[sourceIdx] = null

  // Remove gaps after change
  const moved = expanded.filter(Boolean)

  // Assign new values for sort order
  const toUpdate = moved.map((item, i) => ({
    id: item.id,
    flow_order: i + 1
  }))

  return toUpdate
}

export const doAlphabeticalSort = (ascending: boolean, taskSettings: any[]) => {
  const toSort = [...taskSettings]
  if (ascending) {
    toSort.sort((a, b) => a.name.localeCompare(b.name))
  } else {
    toSort.sort((a, b) => b.name.localeCompare(a.name))
  }
  return toSort.map((item, i) => ({
    ...item,
    flow_order: i + 1
  }))
}
